<template>
  <div>
    <br />
        <v-container class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="4" md="4">
              <v-card class="pa-2" outlined tile>
                  <ul>
                    <li>Customer Satisfaction Rate - CSR</li>
                    <li>Net Promoters Rate - NPR</li>
                    <li>Average Profit Margin - APM</li>
                    <li>Total Revenue Growth - TRG</li>
                    <li>Monthly Recurring Revenue - MRR</li>
                    <li>Sell Through Rate - STR</li>
                    <li>Average Purchase Value - APV</li>
                    <li>Average Conversion Rate - ACR</li>
                    <li>Customer Retention Rate - CRR</li>
                    <li>Customer Churn Rate - CCR</li>
                  </ul>
               </v-card>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-card class="pa-2" outlined tile>
                <div>
                  <section v-if="errored">
                    <p>
                      We are sorry, we are not able to retrieve this information
                      at the moment. Please try back later.
                    </p>
                  </section>
                  <section v-else>
                    <div v-if="loading">Loading...</div>
                    <!-- Responsive & Accessible Data Table  -->
                    <div v-else class="container">
                      <h2>TOP 5 selling products</h2>
                      <table class="responsive-table">
                        <thead>
                          <tr>
                            <th scope="col">Product name</th>
                            <th scope="col">No. sold</th>
                            <th scope="col">Avg. Monthly Sales</th>
                            <th scope="col">Avg. Monthly Profit</th>
                            <th scope="col">Total Sales</th>
                            <th scope="col">Total Profit</th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr> <!-- v-for="paymentInfo in paymentInfo" v-bind:key="paymentInfo" -->
                            <th scope="row">Product #1</th>
                            <td data-title="No. sold">550</td>
                            <td data-title="Avg. Monthly Sales">250 EUR </td>
                            <td data-title="Avg. Monthly Profit">55 EUR</td>
                            <td data-title="Total sales">1500 EUR</td>
                            <td data-title="Total Profit">650 EUR</td>

                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!------------------------------------>
                  </section>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
    <!-- <p v-else>
      Loading products
    </p> -->
  </div>
</template>

<script>
import axios from 'axios'
// import ProductService from '@/services/ProductService.js'

//import ProductCard from '@/components/ui/ProductCard.vue'
// import UnitCard from '@/components/ui/UnitCard.vue'
//import ProductCategoryCard from '@/components/ui/ProductCategoryCard.vue'

//import { mapState } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      isLoading: true,
      clientInfo: null,
      loading: true,
      errored: false,
      id: this.client.id  //! sql: "DELETE from clients WHERE id = 'undefined'"
    }
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/clients`)
      .then(response => {
        this.clientInfo = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))  },
  methods: {
    deleteClient() {
      if (confirm('are you sure?')) {
        this.$store
          .dispatch('client/removeClient', this.id)
          // .then(() => {
          //   this.$router.push({
          //     path: '/products'
          //   })
          // })
          .catch(e => console.log(e))
      }
    }
  },
  props: {
    client: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Breakpoints
$bp-maggie: 15em; 
$bp-lisa: 30em;
$bp-bart: 48em;
$bp-marge: 62em;
$bp-homer: 90em;

// Styles
// * {
//   @include box-sizing(border-box);
  
//   &:before{
//     @include box-sizing(border-box);
//   }
//   &:after {
//     @include box-sizing(border-box);
//   }
// }

// body {
//   font-family: $helvetica;
//   color: rgba(94,93,82,1);
// }

a {
  color: var(--primary);
  
  &:hover,
  &:focus {
    color: var(--primary); 
  }
}

.container {
  // margin: 5% 3%;
  
  @media (min-width: $bp-bart) {
    // margin: 2%; 
  }
  
  @media (min-width: $bp-homer) {
    // margin: 2em auto;
    // max-width: $bp-homer;
  }
}

.responsive-table {
  width: 100%;
  margin-bottom: 1.5em;
  border-spacing: 0;
  
  @media (min-width: $bp-bart) {
    font-size: .9em; 
  }
  
  @media (min-width: $bp-marge) {
    font-size: 1em; 
  }
  
  thead {
    // Accessibly hide <thead> on narrow viewports
    position: absolute;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    padding: 0;
    border: 0;
    height: 1px; 
    width: 1px; 
    overflow: hidden;
    
    @media (min-width: $bp-bart) {
      // Unhide <thead> on wide viewports
      position: relative;
      clip: auto;
      height: auto;
      width: auto;
      overflow: auto;
    }
    
    th {
      background-color: var(--bg-light); 
      border: 1px solid var(--bg-light); 
      font-weight: normal;
      text-align: center;
      color: var(--bright); 
      
      &:first-of-type {
        text-align: left; 
      }
    }
  }
  
  // Set these items to display: block for narrow viewports
  tbody,
  tr,
  th,
  td {
    display: block;
    padding: 0;
    text-align: left;
    white-space: normal;
  }
  
  tr {   
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row; 
    }
  }
  
  th,
  td {
    padding: .5em;
    vertical-align: middle;
    
    @media (min-width: $bp-lisa) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-cell;
      padding: .5em;
    }
    
    @media (min-width: $bp-marge) {
      padding: .75em .5em; 
    }
    
    @media (min-width: $bp-homer) {
      padding: .75em; 
    }
  }
  
  caption {
    margin-bottom: 1em;
    font-size: 1em;
    font-weight: bold;
    text-align: center;
    
    @media (min-width: $bp-bart) {
      font-size: 1.5em;
    }
  }
  
  tfoot {
    font-size: .8em;
    font-style: italic;
    
    @media (min-width: $bp-marge) {
      font-size: .9em;
    }
  }
  
  tbody {
    @media (min-width: $bp-bart) {
      // Undo display: block 
      display: table-row-group; 
    }
    
    tr {
      margin-bottom: 1em;
      
      @media (min-width: $bp-bart) {
        // Undo display: block 
        display: table-row;
        border-width: 1px;
      }
      
      &:last-of-type {
        margin-bottom: 0; 
      }
      
      &:nth-of-type(even) {
        @media (min-width: $bp-bart) {
          background-color: rgba(94,93,82,.1);
        }
      }
    }
    
    th[scope="row"] {
      background-color: var(--bg-light);
      color: white;
      
      @media (min-width: $bp-lisa) {
        border-left: 1px solid  var(--bg-light);
        border-bottom: 1px solid  var(--bg-light);
      }
      
      @media (min-width: $bp-bart) {
        background-color: transparent;
        color: rgba(94,93,82,1);
        text-align: left;
      }
    }
    
    td {
      text-align: right;
      
      @media (min-width: $bp-bart) {
        border-left: 1px solid var(--bg-light); 
        border-bottom: 1px solid  var(--bg-light);
        text-align: center; 
      }
      
      &:last-of-type {
        @media (min-width: $bp-bart) {
          border-right: 1px solid  var(--bg-light);
        } 
      }
    }
    
    td[data-type=currency] {
      text-align: right; 
    }
    
    td[data-title]:before {
      content: attr(data-title);
      float: left;
      font-size: .8em;
      color: rgba(94,93,82,.75);
      
      @media (min-width: $bp-lisa) {
        font-size: .9em; 
      }
      
      @media (min-width: $bp-bart) {
        // Don’t show data-title labels 
        content: none; 
      }
    } 
  }
}
  </style>

